<template>
    <div>
        <kgr-form-row
            :label="$t('offering.settings.instructorNameVisibility')"
            :error="error"
            field-name="instructorNameVisibility"
        >
            <kgr-radio
                v-model="instructorNameVisibility"
                name="instructorNameVisibility"
                :options="instructorNameVisibilityTypes"
                :inline="true"
                @post-input="onInput"
            />
        </kgr-form-row>
    </div>
</template>

<script>
import ClubOfferingSettings from '../../js/dto/offering/ClubOfferingSettings.js';
import Error from '../../js/model/Error.js';
import FormRow from '../common/form/FormRow.vue';
import GenericRadio from '../common/form/radio/GenericRadio.vue';

export default {
    components: {
        'kgr-form-row': FormRow,
        'kgr-radio': GenericRadio,
    },
    props: {
        visibility: {
            type: String,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            instructorNameVisibility: null,
            instructorNameVisibilityTypes: {
                'offering.settings.instructorNameVisibility.firstNameAndLastName': ClubOfferingSettings.INSTRUCTOR_NAME_VISIBILITY_FIRST_AND_LAST_NAME,
                'offering.settings.instructorNameVisibility.firstNameOnly': ClubOfferingSettings.INSTRUCTOR_NAME_VISIBILITY_FIRST_NAME_ONLY,
                'offering.settings.instructorNameVisibility.firstNameAndFirstLetterOfLastName': ClubOfferingSettings.INSTRUCTOR_NAME_VISIBILITY_FIRST_NAME_AND_FIRST_LETTER_OF_LAST_NAME,
            },
        };
    },
    created() {
        this.instructorNameVisibility = this.visibility;
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>

<style scoped lang="scss">

</style>
